import React, { useState } from 'react';
import axios from 'axios';
import { Phone, Loader2, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import { track } from '../lib/track';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CallbackForm = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || phone.trim().length < 6) {
      toast.error('Bitte Name und eine gültige Telefonnummer angeben.');
      return;
    }
    setLoading(true);
    track('callback_form_submit', { location: 'kontakt' });
    try {
      await axios.post(`${API}/contact`, {
        name: name.trim(),
        phone: phone.trim(),
        message: 'Rückruf gewünscht (Kontaktseite)',
      });
      setDone(true);
      track('callback_form_success', { location: 'kontakt' });
      toast.success('Vielen Dank! Wir rufen Sie schnellstmöglich zurück.');
      setName('');
      setPhone('');
    } catch (err) {
      track('callback_form_error', { location: 'kontakt' });
      toast.error('Etwas ist schiefgelaufen. Bitte rufen Sie uns direkt an: 0231 39085116');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        className="bg-green-50 border-2 border-green-200 rounded-2xl p-8 text-center"
        data-testid="callback-form-success"
      >
        <CheckCircle className="w-12 h-12 text-green-600 mx-auto mb-4" />
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Anfrage erhalten!</h3>
        <p className="text-gray-700 mb-4">
          Wir rufen Sie schnellstmöglich zurück. Im Notfall erreichen Sie uns sofort telefonisch.
        </p>
        <button
          onClick={() => setDone(false)}
          className="text-orange-600 font-semibold hover:text-orange-700"
          data-testid="callback-form-reset"
        >
          Weitere Anfrage senden
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-orange-200" data-testid="callback-form">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Kostenlosen Rückruf anfordern</h2>
      <p className="text-gray-600 mb-6">
        Kein Notfall? Lassen Sie sich zurückrufen – einfach Name und Telefonnummer eintragen.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="cb-name" className="block text-sm font-semibold text-gray-700 mb-1">
            Name
          </label>
          <input
            id="cb-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Ihr Name"
            autoComplete="name"
            required
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-colors"
            data-testid="callback-name-input"
          />
        </div>
        <div>
          <label htmlFor="cb-phone" className="block text-sm font-semibold text-gray-700 mb-1">
            Telefonnummer
          </label>
          <input
            id="cb-phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="z. B. 0231 39085116"
            autoComplete="tel"
            required
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none transition-colors"
            data-testid="callback-phone-input"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white px-6 py-4 rounded-full font-bold text-lg transition-all shadow-lg hover:shadow-xl"
          data-testid="callback-submit-button"
        >
          {loading ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              Wird gesendet…
            </>
          ) : (
            <>
              <Phone className="w-5 h-5" />
              Rückruf anfordern
            </>
          )}
        </button>
        <p className="text-xs text-gray-500 text-center">
          Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.
        </p>
      </form>
    </div>
  );
};

export default CallbackForm;
